module.exports = __webpack_public_path__ + "img/etray_instruct.c0ddacd2.png";